import SwalBase from 'sweetalert2';

export const SwalBaseConfig = {
    buttonsStyling: false,
    position: 'top',
    customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-default',
        denyButton: 'btn btn-default',
    },
};

export const Swal = SwalBase.mixin(SwalBaseConfig);
